import { DocumentLibrary } from './../interface/enrollment/document-library.interface';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { AcknowledgementType } from '../enums/acknowledgementType.enum';
@Injectable()
export class DocumentService {

    constructor(
        private _http: Http
    ) { }

    getDocuments(portalId: number, customerTypeId: number, displaySectionId: number,countryCode: string,languageCode:string)
    : Observable<any> {
        return (this._http
          .get(ApiUrlConstants.accountApiUrl + 'documents?countryCode=' + countryCode + '&portal=' + portalId
            + '&customerTypeId=' + customerTypeId + '&preferredLangCode=' + languageCode + '&displaySectionId=' + displaySectionId)
          .map((res: Response) => res.json())
          .catch(this.handleErrorObservable));
      }
/**
 * @description
 * @date 2019-09-09
 * @param {string} governmentId
 * @param {string} countryCode
 * @param {number} storeId
 * @param {number} [memberId]
 * @returns {Observable<any>}
 * @memberof DocumentService
 */
validateGovernmentId(governmentId: string, countryCode: string, storeId: number, memberId?: number)
      : Observable<any> {
      let _restUrl = ApiUrlConstants.accountApiUrl + 'members/check-unique-identification/?storeId=' + storeId
          + '&governmentId=' + governmentId + '&countryCode=' + countryCode;
      if (memberId) {
          _restUrl = _restUrl + '&memberId=' + memberId;
      }
      return this._http
          .get(_restUrl)
          .map((res: Response) => res.json())
          .catch(this.handleErrorObservable);
  }

  updateAcknowledgedDocuments(document: DocumentLibrary, memberTypeId: number, memberId: number) {
    const acknowledgementRequest = {
        title: document.title,
        recordId: document.documentLibraryId.toString(),
        acknowledgementType: AcknowledgementType.ACCEPTED,
        memberType: memberTypeId.toString(),
        documentLibraryVersionId: document.documentLibraryVersionId.toString(),
    };
    return this._http
        .post(ApiUrlConstants.manageAccountApiGwUrl + '/members/' + memberId + '/acknowledgement', acknowledgementRequest)
        .map((res: Response) => res.json())
        .catch(this.handleErrorObservable);
}

/**
 * @description
 * @date 2019-09-04
 * @private
 * @param {(Response | any)} error
 * @returns
 * @memberof DocumentService
 */
private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/document.service.ts